import React, { useMemo } from 'react';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import { ApolloProvider } from '@apollo/client/react';
import { SetContextLink } from '@apollo/client/link/context';
import { getApiToken } from './authService';
import { useAuthContext } from './authContext'; // Adjust path as needed
import { getApiBaseUrl } from '../config/appConfig';

const GRAPHQL_ENDPOINT = `${getApiBaseUrl()}/graphql`;

export default function ApolloProviderWithAuth({ children }) {
  const { msalInstance, account } = useAuthContext();

  const httpLink = useMemo(() => new HttpLink({
    uri: GRAPHQL_ENDPOINT,
  }), []);

const authEnabled = String(import.meta.env?.VITE_AUTH_ENABLED ?? '').toLowerCase() === 'true';

const authLink = useMemo(() =>
  new SetContextLink(async (prevContext, operation) => {
    const token = authEnabled ? await getApiToken(msalInstance, account).catch(() => null) : null;
    return {
      headers: {
        ...prevContext.headers,
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      }
    };
  }), [msalInstance, account, authEnabled]
);

  const client = useMemo(() =>
    new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: { errorPolicy: 'all' },
        query: { errorPolicy: 'all' },
      },
    }), [authLink, httpLink]
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}